import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    token: null,
    error: null,
    loading: false,
    currentUser: {},
    currentUserWithPermissionData: {},
    userPermissions: [],
    userGroups: [],
    userContentTypes: [],
    loggedInEmployee: {},
    headerTitle: 'Dashboard',
    
}

const authStart = (state, action) => {
    return updateObject(state, {
        error: null,
        loading: true
    })
}

const authSuccess = (state, action) => {
    return updateObject(state, {
        token: action.token,
        error: null,
        loading: false,
        currentUser: action.currentUser
    })
}

const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const authLogout = (state, action) => {
    return updateObject(state, {
        token: null
    })
}

const fetchLoggedInEmployee = (state, action) => {
    return updateObject(state, {
        loggedInEmployee: action.loggedInEmployee
    })
}

const fetchUserWithPermissionsData = (state, action) => {
    return updateObject(state, {
        currentUserWithPermissionData: action.userWithPermissionsData
    })
}

const changeHeaderTitle = (state, action) => {
    return updateObject(state, {
        headerTitle: action.headerTitle
    })
}

const changeUserPermissions = (state, action) => {
    return updateObject(state, {
        userPermissions: action.userPermissions,
        userGroups: action.userGroups,
        userContentTypes: action.userContentTypes
    })
}

const reducer = (state=initialState, action) => {
    switch(action.type){
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        
        case actionTypes.FETCH_LOGGEDIN_EMPLOYEE: return fetchLoggedInEmployee(state, action);
        case actionTypes.FETCH_USER_WITH_PERMISSIONS_DATA: return fetchUserWithPermissionsData(state, action);
        case actionTypes.CHANGE_HEADER_TITLE: return changeHeaderTitle(state, action);
        case actionTypes.LOAD_USER_PERMISSIONS: return changeUserPermissions(state, action);
        default: return state;
    }
}

export default reducer;